module.exports = "/fonts/themify.svg?9c8e96ecc7fa01e6ebcd196495ed2db5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/themify-icons/fonts/themify.svg
// module id = 58
// module chunks = 23